import { render } from "./Option.vue?vue&type=template&id=845bf5ae&scoped=true"
import script from "./Option.vue?vue&type=script&lang=js"
export * from "./Option.vue?vue&type=script&lang=js"

import "./Option.vue?vue&type=style&index=0&id=845bf5ae&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845bf5ae"]])

export default __exports__